











import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import MaskLayer from "./maskLayer.vue";

@Component({
  components: {
    MaskLayer
  }
})
export default class GuideMask extends Vue {
  /* -------------- prop ------------- */
  @Prop(String) guideImgUrl?: string; // guide img 背景图片
  @Prop({ default: false }) maskActive?: boolean;

  /* -------------- emit ------------- */

  @Emit()
  closeMask () {
    /* close mask */
  }
}
